import React, {useState} from 'react';
import {createGUID, getCurrencyCode} from '../../../util/utility';
import {CoveragesItem} from '../Coverages';
import CoveragesListItem from './CoveragesListItem';
import '../styles.scss';
import {uriGetTopDetailV2Coverages} from '../../../api/endpoints';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {get} from '../../../api/api';
import Icon from '../../../components/icon';
import {Icons} from '../../../util/icons';
import colors from '../../../util/colors';
import {strings} from '../../../util/strings';

export interface CoveragesListProps {
  selectedBu: any;
  coveragesList: CoveragesItem[];
  setCoverageDetails?: any;
  setSelectedItem(value: CoveragesItem): void;
  setShowModal(value: boolean): void;
  setErrorFetchingDetail(value: boolean): void;
  showUniversalDeductHeader?: boolean;
  universalDeductsTitle?: string;
  universalDeductsDescription?: string;
  universalDeductAmt?: number | string;
  currency?: string;
  buStyles?: any;
  userLanguage?: string;
}

function CoveragesList({
  selectedBu,
  coveragesList,
  setCoverageDetails,
  setSelectedItem,
  setShowModal,
  setErrorFetchingDetail,
  showUniversalDeductHeader,
  universalDeductsTitle,
  universalDeductsDescription,
  universalDeductAmt,
  currency,
  buStyles,
  userLanguage,
}: CoveragesListProps) {
  const [isUniversalDeductOpen, setIsUniversalDeductOpen] = useState(false);
  const featureName = 'CoveragesList';

  const formatAmount = (value?: number | string) => {
    if (value === undefined || value === null || value === '') {
      return '';
    }
    let numVal: number;
    if (typeof value === 'number') {
      numVal = value;
    } else if (typeof value === 'string') {
      const cleaned = value.replace(/\s/g, '').replace(',', '.');
      numVal = parseFloat(cleaned);
    } else {
      numVal = Number(value);
    }
    const currSymbol =
      getCurrencyCode(currency, 'myCoverages') || currency || '€';
    if (isNaN(numVal)) {
      return `${value} ${currSymbol}`.trim();
    }
    const formatted = new Intl.NumberFormat(userLanguage || 'pt-PT', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(numVal);
    return `${formatted} ${currSymbol}`.trim();
  };

  const handleDisplayCoverageDetails = async (
    element: CoveragesItem,
    e: React.MouseEvent,
  ) => {
    e.preventDefault();
    await get(
      uriGetTopDetailV2Coverages(
        selectedBu.buId,
        selectedBu.benNbr,
        element.idReg,
        selectedBu.memId,
      ),
      false,
      0,
      featureName,
    )
      .then((res: any) => {
        setCoverageDetails(res.data.items);
      })
      .catch(() => {
        setErrorFetchingDetail(true);
        setCoverageDetails([]);
      })
      .finally(() => {
        setSelectedItem(element);
        setShowModal(true);
      });
  };

  const primaryColor = buStyles?.primaryColor || colors.blue;

  return (
    <>
      {showUniversalDeductHeader && (
        <div className="universal-deduct-container">
          <div
            className="universal-deduct-header"
            data-testid="universal-deduct-header"
            onClick={() => setIsUniversalDeductOpen(!isUniversalDeductOpen)}>
            <span className="universal-deduct-title">
              {universalDeductsTitle ||
                strings.pt.myCoverages.coverages_universalDeductsTitle}
            </span>
            <div className="universal-deduct-right-section">
              {universalDeductAmt !== undefined &&
                universalDeductAmt !== null &&
                universalDeductAmt !== '' &&
                formatAmount(universalDeductAmt) !== '' && (
                  <span
                    className="universal-deduct-amount"
                    data-testid="universal-deduct-amount">
                    {formatAmount(universalDeductAmt)}
                  </span>
                )}
              <div className="universal-deduct-icon-container">
                <Icon
                  name={
                    isUniversalDeductOpen
                      ? Icons.CHEVRON_WITH_CIRCLE_UP
                      : Icons.CHEVRON_WITH_CIRCLE_DOWN
                  }
                  color={primaryColor}
                  width="20"
                  height="20"
                />
              </div>
            </div>
          </div>
          {isUniversalDeductOpen && (
            <div
              className="universal-deduct-content"
              data-testid="universal-deduct-description">
              {universalDeductsDescription ||
                strings.pt.myCoverages.coverages_universalDeductsDescription}
            </div>
          )}
        </div>
      )}
      {coveragesList?.map((element: CoveragesItem) => (
        <div
          key={createGUID()}
          onClick={(e) => handleDisplayCoverageDetails(element, e)}
          style={{cursor: 'pointer'}}>
          <CoveragesListItem
            key={createGUID()}
            coveragesItem={element}></CoveragesListItem>
        </div>
      ))}
    </>
  );
}
const mapStateToProps = ({selectedBu, user, language}: any) => ({
  selectedBu: selectedBu?.value,
  userLanguage: language?.value || user?.value?.language,
});

export {CoveragesList};
export default compose(connect(mapStateToProps)(CoveragesList));
